import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserSharedByMe = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.6247 8.14873V3.64335C12.6246 3.51831 12.6599 3.39594 12.7264 3.29125C12.7929 3.18657 12.8877 3.1041 12.999 3.05395C13.1104 3.0038 13.2336 2.98816 13.3535 3.00893C13.4734 3.0297 13.5848 3.08599 13.674 3.1709L21.7988 10.8845C21.8622 10.9447 21.9129 11.0177 21.9475 11.099C21.9821 11.1804 22 11.2682 22 11.3569C22 11.4457 21.9821 11.5335 21.9475 11.6148C21.9129 11.6961 21.8622 11.7692 21.7988 11.8294L13.674 19.543C13.5848 19.6279 13.4734 19.6842 13.3535 19.7049C13.2336 19.7257 13.1104 19.7101 12.999 19.6599C12.8877 19.6098 12.7929 19.5273 12.7264 19.4226C12.6599 19.3179 12.6246 19.1956 12.6247 19.0705V14.5786C5.33053 14.7663 4.06244 18.2535 3.21059 20.5817C3.15938 20.723 3.0615 20.8413 2.93408 20.9159C2.80666 20.9905 2.6578 21.0166 2.51354 20.9897C2.36929 20.9628 2.23881 20.8846 2.14493 20.7688C2.05106 20.653 1.99975 20.5069 2 20.3561C2 10.0071 7.02735 8.26058 12.6247 8.14873Z",
		fill: "#636C7B"
	})
});
export default SvgUserSharedByMe;
